<template>
  <section id="Usuarios" class="section-item">
    <h1>{{ $t("title.users") }}</h1>

    <section id="api-Usuarios-PostUsersInvite">
      <h2>{{ $t("title.users") }} - {{ $t("title.invite_user") }}</h2>
      <p>{{ $t("users.create_user_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/users/invite</code></pre>
      </div>
      <div class="code-toggle">
        <button
          @click="selectedTab = 'json'"
          :class="{ active: selectedTab === 'json' }"
        >
          JSON
        </button>
        <button
          @click="selectedTab = 'curl'"
          :class="{ active: selectedTab === 'curl' }"
        >
          cURL
        </button>
      </div>

      <pre v-if="selectedTab === 'json'">
              <code class="language-json">{   
   "email":"email@mail.com",
   "role":"developer"
}</code></pre>

      <pre v-if="selectedTab === 'curl'">
              <code class="language-bash">curl -XPOST -H "Content-type: application/json" -d '{"email":"email@mail.com","role":"developer"}' 'https://{{ whitelabel?.api_domain }}/v1/users/invite'
-u '[SEU ID]:[SEU TOKEN]'</code>
            </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>email</td>
            <td>String</td>
            <td>{{ $t("table.user_email") }}</td>
          </tr>
          <tr>
            <td>role</td>
            <td>String</td>
            <td>{{ $t("table.user_permission_level") }}</td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>success</td>
            <td>String</td>
            <td>{{ $t("table.success_message") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>

      <pre>
              <code class="language-json">HTTP/1.1 200 OK
{
   "success":"Convite enviado"
}</code>
            </pre>

      <button class="btn02">Error-Response</button>
      <pre>
              <code class="language-json">{
        "error": "Error message"
}</code>
            </pre>
    </section>

    <section id="api-Usuarios-DeleteUsers">
      <h2>{{ $t("title.users") }} - {{ $t("ttile.delete_user") }}</h2>
      <p>{{ $t("sms.group_deletion_method") }}</p>
      <div class="">
        <div class="delete type">DELETE</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/users</code></pre>
      </div>
      <div class="code-toggle">
        <button
          @click="selectedTab = 'json'"
          :class="{ active: selectedTab === 'json' }"
        >
          JSON
        </button>
        <button
          @click="selectedTab = 'curl'"
          :class="{ active: selectedTab === 'curl' }"
        >
          cURL
        </button>
      </div>

      <pre v-if="selectedTab === 'curl'">
              <code class="language-bash">curl -XDELETE -H "Content-type: application/json" -d '{"id":"3164512a-6f4a-46ff-9cdd-e14619001ad8"}' 'https://{{ whitelabel?.api_domain }}/v1/users'
-u '[SEU ID]:[SEU TOKEN]'</code>
            </pre>

      <pre v-if="selectedTab === 'json'">
              <code class="language-json">{   
  "id":"9864512a-6f4a-46ff-6cdd-e14619001ad7"
}</code>
            </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>Array</td>
            <td>{{ $t("table.user_id_to_delete") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>

      <pre>
              <code class="language-json">HTTP/1.1 200 OK
{
  "message":"usuario excluido"
}</code>
            </pre>

      <button class="btn02">Error-Response</button>
      <pre>
              <code class="language-json">{
        "error": "Error message"
      }</code>
            </pre>
    </section>

    <section id="api-Usuarios-GetUsers">
      <h2>{{ $t("title.users") }} -{{ $t("title.list_users") }}</h2>
      <p>{{ $t("users.list_users_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/users</code></pre>
      </div>

      <pre>
              <code class="language-bash">curl -XGET -H "Content-type: application/json" 'https://{{ whitelabel?.api_domain }}/v1/users'
-u '[SEU ID]:[SEU TOKEN]'</code>
            </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.user_id") }}</td>
          </tr>
          <tr>
            <td>name</td>
            <td>String</td>
            <td>{{ $t("table.account_name") }}</td>
          </tr>
          <tr>
            <td>email</td>
            <td>String</td>
            <td>{{ $t("table.user_email") }}</td>
          </tr>
          <tr>
            <td>password</td>
            <td>String</td>
            <td>{{ $t("table.password_hash") }}</td>
          </tr>
          <tr>
            <td>mobile_number</td>
            <td>String</td>
            <td>{{ $t("table.user_mobile_number") }}</td>
          </tr>
          <tr>
            <td>type</td>
            <td>String</td>
            <td>{{ $t("table.account_type") }}</td>
          </tr>
          <tr>
            <td>current_account</td>
            <td>String</td>
            <td>{{ $t("table.current_account") }}</td>
          </tr>
          <tr>
            <td>pivot</td>
            <td>Object</td>
            <td>{{ $t("table.pivot") }}.</td>
          </tr>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("table.account_association") }}</td>
          </tr>
          <tr>
            <td>user_id</td>
            <td>String</td>
            <td>{{ $t("table.user_id") }}</td>
          </tr>
          <tr>
            <td>role</td>
            <td>String</td>
            <td>{{ $t("table.user_role") }}</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>String</td>
            <td>{{ $t("table.creation_date") }}</td>
          </tr>
          <tr>
            <td>updated_at</td>
            <td>String</td>
            <td>{{ $t("table.update_date") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>
      <pre>
              <code class="language-json">HTTP/1.1 200 OKs
[
  {     
     "id":"1bfaag22-19de-40a3-ab66-785a3f13b331",
     "name":null,
     "email":"lucas@tew.one",
     "created_at":"2020-08-05T14:02:26.000000Z",
     "updated_at":"2020-08-05T14:02:26.000000Z",
     "password":"aDS9D8JrC.picPl.42ccPzAZidORAD8SUD8AbsnY9SnpHFfGp1eCM9i.qm",
     "mobile_number":null,
     "current_account":null,
     "pivot":{
     "account_id":"f98c24ed-8339-4c4f-a2e8-143f26020f58",
     "user_id":"1bfaag22-19de-40a3-ab66-785a3f13b331",
     "role":"developer"
     }
   }
]</code>
            </pre>

      <button class="btn02">Error-Response</button>
      <pre>
              <code class="language-json">{
        "error": "Error message"
}</code>
            </pre>
    </section>
  </section>
</template>

<script>
import hljs from "highlight.js";
import "highlight.js/styles/an-old-hope.css";

export default {
  name: "UsersComponent",
  data() {
    return {
      selectedTab: "json",
    };
  },
  mounted() {
    this.highlightCode();
  },
  watch: {
    selectedTab() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
  },
  methods: {
    highlightCode() {
      document.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
      });
    },
  },
};
</script>

<style scoped>
.sms-method {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

pre[class*="language-"] {
  background-color: #000 !important;
  color: var(--green-code);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  font-family: var(--font-code);
  margin-bottom: 20px;
}
</style>
